import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import './index.css';

export default class _siderMenu extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        menuType: PropTypes.string,
    };

    constructor(props) {
        super(props);
        this.state = {
            curActive: null,
        }
    }

    componentDidMount() {
    }

    render() {
        const { className, title, menuType, active, url } = this.props;
        console.log("videoTypeList >>>>>>>>> ", this.props.videoTypeList);
        return (
            <div className={className} styleName="sider_menu">
                <div styleName="sider_menu_title">{title}</div>

                {
                    this.props.videoTypeList?.map(item =>
                        <div
                            // key={index}
                            styleName={classNames('sider_menu_item', {active: this.state.curActive == item.DM})}
                            onClick={() => {
                                this.props.changeType(item);
                                this.setState({curActive: item.DM});
                            }}
                        >
                            {item.MC}
                        </div>
                    )
                }
            </div>
        );
    }
}
//属性检查
_siderMenu.propTypes = {
    setMenuList: PropTypes.func, //选择完成后的回调
}